/**
 * Icon Component
 * SVG icon wrapper with path support
 */
import React from 'react';

export const Icon = ({ path, className = 'w-6 h-6' }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    className={className}
  >
    <path d={path} />
  </svg>
);

export default Icon;

